import { createSlice } from "@reduxjs/toolkit";

const initialState = { lystMatteAdded: false, scrollAllowed: false };
const layout = createSlice({
    name: "layout",
    initialState,
    reducers: {
        addLystMatte(state): void {
            state.lystMatteAdded = true;
            state.scrollAllowed = false;
        },
        addLystMatteWithScroll(state): void {
            state.lystMatteAdded = true;
            state.scrollAllowed = true;
        },
        removeLystMatte(state): void {
            state.lystMatteAdded = false;
            state.scrollAllowed = false;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = layout;
// Extract and export each action creator by name
export const { addLystMatte, addLystMatteWithScroll, removeLystMatte } = actions;
// Export the reducer, either as a default or named export
export default reducer;
